/**
 * iPhone / iPad / iPod, including iPadOS / iPhone “Request Desktop Website”
 * which reports a Macintosh UA.
 */
export function isLikelyIosDevice() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return true;
  const touchPoints = Number(navigator.maxTouchPoints) || 0;
  if (navigator.platform === 'MacIntel' && touchPoints > 0) return true;
  if (/Macintosh/i.test(ua) && touchPoints > 1) return true;
  return false;
}
